import { FC } from 'react';
import { useDesign, useServices } from '../../../hooks';
import {
  BreakingChangeType,
  Design,
  DesignFeatureFlag,
  Option
} from '../../../types';
import { addBreakingChange } from '../../../utilities';
import { DesignRootFeatureFlag } from './design-root-feature-flag';

const designFeatureFlagOptions: Option<DesignFeatureFlag>[] = [
  {
    label: 'Intent Management',
    value: DesignFeatureFlag.intentManagement
  },
  {
    label: 'Multiple TTS Voices per Locale',
    value: DesignFeatureFlag.ttsOverrides
  }
];

export const DesignRootFeatureFlags: FC = () => {
  const serialized = useDesign();
  const { intentService } = useServices();
  const { features } = serialized.rootSettings;

  return (
    <div className="row">
      <div className="col-md-12">
        <label>Feature Flags</label>
        <div className="box content equalChildren">
          {/* OmniChannel is old and was created before @see designFeatureFlagOptions so it must be handled separately. */}
          <DesignRootFeatureFlag
            enabled={serialized.omniChannel.isOmniChannel}
            label={window.l.settings.omniChannel}
            onEnable={async () => {
              enableOmniChannel(serialized);
            }}
            tooltip="Enables the use of conversation variables and multiple session channels"
          />
          {designFeatureFlagOptions.map(({ label, value: flagId }) => {
            const enabled = !!features[flagId];
            return (
              <DesignRootFeatureFlag
                enabled={enabled}
                key={flagId}
                label={label}
                onEnable={async () => {
                  features[flagId] = true;
                  serialized.rootSettings.lastLocalChange = window.apm.timestamp;
                  switch (flagId) {
                    case DesignFeatureFlag.intentManagement: {
                      await intentService.hydrateDesign(serialized);
                    }
                  }
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

function enableOmniChannel(serialized: Design) {
  window.apm.knowledgeBase.addScopeToAppVariables(serialized.components.variables);
  window.apm.knowledgeBase.udgradePromptConfigForSimultaneous(serialized);

  serialized.omniChannel = {
    isOmniChannel: true,
    lastLocalChange: window.apm.timestamp
  };

  addBreakingChange(serialized, {
    message: 'Omni Channel enabled.',
    timestamp: window.apm.timestamp,
    type: BreakingChangeType.omniChannelEnabled
  });

  // TODO: only refresh tabs whose flows contain prompts
  window.apm.postEventToAllViews({ target: 'request-reload-data-model' });
}
